import { updateWidgetLayout } from "actions/editor";
import { FORM_FIELD } from "constants/widgetTypes";
import _ from "lodash";
import { getBoundingRectForWidget, getBoundingRectFromLayout } from "./layoutManager";

import { Frame } from 'scenejs';

const fieldWidget = (config) => {
  return {
    type: FORM_FIELD,
    name: config.label,
    properties: {
      desktop: {
        visible: true,
        field: config.field,
        label: config.label,
        placeholder: config.placeholder,
        mandatory: false,
        layout: {
          transform: {
            translate: `${config.x}px, ${config.y}px`,
            rotate: "0deg"
          },
          width: '540px',
          height: 'auto'
        },
        styles: {
          layout: {
            alignment: "left",
            labelPadding: "0",
            inputPadding: "12",
            fieldSpacing: "2",
            regular: null
          },
          regular: {
            border: {
              sides: null,
              color: {
                r: 0,
                g: 0,
                b: 0,
                a: 1
              },
              width: "2",
              radius: null,
              style: "bottom"
            },
            label: {
              background: null,
              color: {
                r: 0,
                g: 0,
                b: 0,
                a: 1
              },
              placeholderColor: null,
              font: {
                style: null,
                fontSize: "12",
                fontFamily: "Montserrat,sans-serif",
                lineSpacing: null,
                letterSpacing: null,
                color: null
              }
            },
            input: {
              background: {
                r: 255,
                g: 255,
                b: 255,
                a: 1
              },
              color: {
                r: 0,
                g: 0,
                b: 0,
                a: 1
              },
              placeholderColor: {
                r: 213,
                g: 213,
                b: 213,
                a: 1
              },
              font: {
                style: null,
                fontSize: "14",
                fontFamily: "Montserrat,sans-serif",
                lineSpacing: null,
                letterSpacing: null,
                color: null
              }
            }
          }
        }
      },
      mobile: {
        visible: true,
        layout: {
          transform: {
            translate: `0px, 0px`,
            rotate: "0deg"
          },
          width: '295px',
          height: 'auto'
        },
      }
    }
  }
};

export const createAddFieldRequest = (editorSession, form, field, afterField) => {
  const formRect = getBoundingRectForWidget(editorSession, form);
  const rect = getBoundingRectForWidget(editorSession, afterField);

  const x = rect.x;
  const y = rect.y + rect.height + 30;

  const fieldConfig = {
    ...field,
    x: x,
    y: y
  }

  const fieldRequest = fieldWidget(fieldConfig);
  return fieldRequest;
}

export const moveWidgetsInForm = (editorSession, widgets, lastField) => {
  const fieldRect = getBoundingRectForWidget(editorSession, lastField);
  const topOffset = fieldRect.y + fieldRect.height - 2;
  const heightOffset = fieldRect.height + 30;

  const requests = widgets.filter(widget => {
    const layout = _.get(widget, 'properties.desktop.layout');
    const rect = getBoundingRectFromLayout(layout);
    return rect.y >= topOffset;
  }).map(widget => {
    const layout = _.get(widget, 'properties.desktop.layout');
    const rect = getBoundingRectFromLayout(layout);

    const frame = new Frame(layout);
    const x = rect.x;
    const y = rect.y + heightOffset;

    frame.set('transform', 'translate', `${x}px, ${y}px`);

    return updateWidgetLayout(editorSession, widget.uid, 'desktop', frame.get());
  });

  return requests;
}

export const calculateHeightForForm = (editorSession, breakpoint, form) => {

}